import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { Country } from '../../shared/interface/country.interface';
import { Address } from '../interface/address';
import { SearchAddressModelResponse } from '../interface/search-address-model-response.interface';

@Injectable()
export class AddressService {
    // private _schemaForm = environment.uiTemplateBaseUrl + '/test/' ;
    private _schemaForm = environment.cdnURL + '/portals/customercare/template1/schema-forms/';
    constructor(
        private _http: Http,
        private _httpClient: HttpClient
    ) { }

    /**
     * @param  {any} address
     * @returns Observable
     */
    getSuggestedAddress(address: Address): Observable<Address> {
        return this._http
            .post(ApiUrlConstants.addressApiUrl + 'verify-address', address)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * to get saved addresses
     * @param  {number} memnerId
     */
    getSavedAddress(memberId: number, countryId: number): Observable<any[]> {
        return this._http
            .get(ApiUrlConstants.accountApiUrl + 'members/' + memberId + '/addresses?countryId=' + countryId)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * save verifiedAddress
     * @param  {any} verifiedAddress
     * @returns Observable
     */
    saveVerifiedAddress(verifiedAddress: Address): Observable<any> {
        return this._http
            .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.manageAccountApiGwUrl + 'members/' + verifiedAddress.memberId + '/addresses')), verifiedAddress)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * update Saved Addresses based on memebr id
     * @param  {ShippingAddress} verifiedAddress
     * @param  {number} savedAddressId
     * @returns Observable
     */
    updateVerifiedAddress(verifiedAddress: Address, memberAddressId: number): Observable<any> {
        return this._http
            .put(ApiUrlConstants.manageAccountApiGwUrl + 'members/' + verifiedAddress.memberId + '/addresses/' + memberAddressId, verifiedAddress)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * delete Saved Addresses based on memebr id
     * @param  {number} memberId
     * @param  {number} savedAddressId
     * @param  {number} loggedinUserId
     * @returns Observable
     */
    deleteVerifiedAddress(memberId: number, savedAddressId: number, loggedinUserId: number): Observable<any> {
        return this._http
            .delete(ApiUrlConstants.manageAccountApiGwUrl + 'members/' + memberId +
                '/addresses/' + savedAddressId + '?loggedinUserId=' + loggedinUserId)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description get address details by address id
     * @date 2018-09-17
     * @param {number} addressId
     * @returns {Observable<Address>}
     * @memberof AddressService
     */
    getAddressDetailsById(addressId: number): Observable<Address[]>  {
        const  url  =  ApiUrlConstants.accountApiUrl  +  'members/addresses/' + addressId;
        return  this._http
            .get(url)
            .map((res:  Response)  =>  res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description
     * @date 2020-03-19
     * @param {Country} country
     * @param {string} [searchText]
     * @param {string} [displayName]
     * @param {number} [uniqueIdentifier]
     * @returns {Observable<SearchAddressModelResponse>}
     * @memberof AddressService
     */
    getSearchAddress(country: Country, searchText?: string, displayName?: string, uniqueIdentifier?: number)
        : Observable<SearchAddressModelResponse> {
        let url = ApiUrlConstants.addressApiUrl + 'search-address?isocodeTwo='
            + country.isocodeTwo + '&isocodeThree=' + country.isocodeThree;
        if (searchText) {
            url = url + '&searchTerm=' + encodeURIComponent(searchText);
        }
        if (displayName && uniqueIdentifier) {
            url = url + '&uniqueIdentifier=' + uniqueIdentifier + '&displayName=' + encodeURIComponent(displayName);
        }
        if (displayName && !uniqueIdentifier) {
            url = url + '&displayName=' + encodeURIComponent(displayName);
        }
        return this._http
            .get(url)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To get spatial info
     * @param  postalCode
     * @param  countryCode
     * @returns Observable
     */
    getSpatialInfo(postalCode: string, countryCode: string): Observable<any> {
        return this._http.get(ApiUrlConstants.addressApiUrl + 'spatial-info?postcode='
            + postalCode + '&isocodeThree=' + countryCode)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @returns Observable
     */
    getJsonFormSchema(schemaUrl: string): Observable<any> {
        let params = new URLSearchParams();
        params.append('timeStamp', new Date().getTime().toString());
        const apiUrl = new URL(this._schemaForm);
        if(schemaUrl !== null) {
            const [path, query] = schemaUrl.split('?');
            apiUrl.pathname += path;
            if (query) {
                query.split('&').forEach(param => {
                    const [key, value] = param.split('=');
                    params.append(key, value || '');
                });
            }
        }
        apiUrl.search = params.toString();
        console.log(apiUrl.toString());
        return this._httpClient
            .get(apiUrl.toString(), { responseType: 'text' })
            .catch(this.handleErrorObservable);
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error.message || error);
    }

    getCitiesList(countryId: any) : Observable<any> {
        return this._http
        .get(ApiUrlConstants.configurationApiUrl + countryId)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/address.service.ts